export function encodePathToFileName(path: string) {
    return path.replaceAll('(','\\(')
    .replaceAll(')','\\)')
    .replaceAll('[','\\[')
    .replaceAll(']','\\]')
    .replaceAll('&','\\&')
    .replaceAll('\'','\\\'')
    .replaceAll(';','\\;')
    .replaceAll(' ','\\ ')
}
